export default {
  "brand.name": "Basetao Spreadsheet",
  "nav.home": "Início",
  "nav.guide": "Guia de compras",
  "nav.review": "Avaliação",
  "nav.shipping": "Envio",
  "nav.qc": "QC",
  "nav.articles": "Artigos",
  "cta.explore": "Explorar Basetao Spreadsheet",
  "cta.buyNow": "Comprar Agora",
  "cta.brand": "Basetao Spreadsheet",
  "cta.readGuide": "Ler o Guia Completo",
  "cta.backHome": "Voltar ao Início",
  "cta.visitMain": "Visitar Nosso Site Principal",
  "footer.tagline": "Recursos, guias e ferramentas independentes de pesquisa de produtos sobre Basetao Spreadsheet.",
  "footer.disclaimer": "Este é um recurso informativo independente. As informações podem mudar e devem ser verificadas de forma independente. Não somos afiliados, endossados nem conectados a nenhum serviço de terceiros mencionado.",
  "footer.rights": "Todos os direitos reservados.",
  "footer.resources": "Recursos",
  "footer.legal": "Jurídico",
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",
};